import {BreakpointObserver} from '@angular/cdk/layout';
import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {distinctUntilChanged, map, switchMap} from 'rxjs';
import {VIEWPORT_MEDIA_QUERIES} from '@aviary/responsiveness/viewport-media-queries';
import {ViewportActions} from '@aviary/store/viewport/viewport.actions';

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in -- This is registered via NgRx; it's not an Angular tree-shakable provider.
@Injectable()
export class ViewportEffects {

  private readonly actions: Actions = inject(Actions);
  private readonly breakpointObserver: BreakpointObserver = inject(BreakpointObserver);

  public readonly watchForViewportSizeChanges = createEffect(() =>
    this.actions.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() =>
        this.breakpointObserver.observe([
          VIEWPORT_MEDIA_QUERIES.lgAndUp,
          VIEWPORT_MEDIA_QUERIES.mdAndUp
        ]).pipe(
          map(state => {
            if (state.breakpoints[VIEWPORT_MEDIA_QUERIES.lgAndUp]) return 'lg';
            if (state.breakpoints[VIEWPORT_MEDIA_QUERIES.mdAndUp]) return 'md';
            return 'sm';
          }),
          distinctUntilChanged(),
          map(ViewportActions.sizeChanged)
        )
      )
    )
  );
}
